import { render, staticRenderFns } from "./EditContent.vue?vue&type=template&id=0915d7ef"
import script from "./EditContent.vue?vue&type=script&lang=js"
export * from "./EditContent.vue?vue&type=script&lang=js"
import style0 from "./EditContent.vue?vue&type=style&index=0&id=0915d7ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports